import React, { useEffect, useState } from 'react';
import { TableCalcStyle, WrapperTables } from './style';

export default function TableCalcReceitas() {
  const [qntJan, setQntJan] = useState(0);
  const [unitValueJan, setUnitValueJan] = useState(0);
  const [totalJan, setTotalJan] = useState(0);
  const [totalAcumuladoJan, setTotalAcumuladoJan] = useState(0);

  const [qntFev, setQntFev] = useState(0);
  const [unitValueFev, setUnitValueFev] = useState(0);
  const [totalFev, setTotalFev] = useState(0);
  const [totalAcumuladoFev, setTotalAcumuladoFev] = useState(0);

  const [qntMar, setQntMar] = useState(0);
  const [unitValueMar, setUnitValueMar] = useState(0);
  const [totalMar, setTotalMar] = useState(0);
  const [totalAcumuladoMar, setTotalAcumuladoMar] = useState(0);

  const [qntAbr, setQntAbr] = useState(0);
  const [unitValueAbr, setUnitValueAbr] = useState(0);
  const [totalAbr, setTotalAbr] = useState(0);
  const [totalAcumuladoAbr, setTotalAcumuladoAbr] = useState(0);

  const [qntMai, setQntMai] = useState(0);
  const [unitValueMai, setUnitValueMai] = useState(0);
  const [totalMai, setTotalMai] = useState(0);
  const [totalAcumuladoMai, setTotalAcumuladoMai] = useState(0);

  const [qntJun, setQntJun] = useState(0);
  const [unitValueJun, setUnitValueJun] = useState(0);
  const [totalJun, setTotalJun] = useState(0);
  const [totalAcumuladoJun, setTotalAcumuladoJun] = useState(0);

  const [qntJul, setQntJul] = useState(0);
  const [unitValueJul, setUnitValueJul] = useState(0);
  const [totalJul, setTotalJul] = useState(0);
  const [totalAcumuladoJul, setTotalAcumuladoJul] = useState(0);

  const [qntAgo, setQntAgo] = useState(0);
  const [unitValueAgo, setUnitValueAgo] = useState(0);
  const [totalAgo, setTotalAgo] = useState(0);
  const [totalAcumuladoAgo, setTotalAcumuladoAgo] = useState(0);

  const [qntSet, setQntSet] = useState(0);
  const [unitValueSet, setUnitValueSet] = useState(0);
  const [totalSet, setTotalSet] = useState(0);
  const [totalAcumuladoSet, setTotalAcumuladoSet] = useState(0);

  const [qntOut, setQntOut] = useState(0);
  const [unitValueOut, setUnitValueOut] = useState(0);
  const [totalOut, setTotalOut] = useState(0);
  const [totalAcumuladoOut, setTotalAcumuladoOut] = useState(0);

  const [qntNov, setQntNov] = useState(0);
  const [unitValueNov, setUnitValueNov] = useState(0);
  const [totalNov, setTotalNov] = useState(0);
  const [totalAcumuladoNov, setTotalAcumuladoNov] = useState(0);

  const [qntDez, setQntDez] = useState(0);
  const [unitValueDez, setUnitValueDez] = useState(0);
  const [totalDez, setTotalDez] = useState(0);
  const [totalAcumuladoDez, setTotalAcumuladoDez] = useState(0);

  const calcTotal = (qnt, value) => {
    let result = qnt * value;
    return result;
  };

  const calcTotalAcumulado = (total, totalAcumulado = 0) => {
    let result = total + totalAcumulado;
    return result;
  };

  useEffect(() => {
    setTotalJan(calcTotal(qntJan, unitValueJan));
    setTotalAcumuladoJan(calcTotalAcumulado(totalJan));

    setTotalFev(calcTotal(qntFev, unitValueFev));
    setTotalAcumuladoFev(calcTotalAcumulado(totalFev, totalAcumuladoJan));

    setTotalMar(calcTotal(qntMar, unitValueMar));
    setTotalAcumuladoMar(calcTotalAcumulado(totalMar, totalAcumuladoFev));

    setTotalAbr(calcTotal(qntAbr, unitValueAbr));
    setTotalAcumuladoAbr(calcTotalAcumulado(totalAbr, totalAcumuladoMar));

    setTotalMai(calcTotal(qntMai, unitValueMai));
    setTotalAcumuladoMai(calcTotalAcumulado(totalMai, totalAcumuladoAbr));

    setTotalJun(calcTotal(qntJun, unitValueJun));
    setTotalAcumuladoJun(calcTotalAcumulado(totalJun, totalAcumuladoMai));

    setTotalJul(calcTotal(qntJul, unitValueJul));
    setTotalAcumuladoJul(calcTotalAcumulado(totalJul, totalAcumuladoJun));

    setTotalAgo(calcTotal(qntAgo, unitValueAgo));
    setTotalAcumuladoAgo(calcTotalAcumulado(totalAgo, totalAcumuladoJul));

    setTotalSet(calcTotal(qntSet, unitValueSet));
    setTotalAcumuladoSet(calcTotalAcumulado(totalSet, totalAcumuladoAgo));

    setTotalOut(calcTotal(qntOut, unitValueOut));
    setTotalAcumuladoOut(calcTotalAcumulado(totalOut, totalAcumuladoSet));

    setTotalNov(calcTotal(qntNov, unitValueNov));
    setTotalAcumuladoNov(calcTotalAcumulado(totalNov, totalAcumuladoOut));

    setTotalDez(calcTotal(qntDez, unitValueDez));
    setTotalAcumuladoDez(calcTotalAcumulado(totalDez, totalAcumuladoNov));
  }, [
    qntJan,
    unitValueJan,
    totalJan,
    totalAcumuladoJan,
    qntFev,
    unitValueFev,
    totalFev,
    totalAcumuladoFev,
    qntMar,
    unitValueMar,
    totalMar,
    totalAcumuladoMar,
    qntAbr,
    unitValueAbr,
    totalAbr,
    totalAcumuladoAbr,
    qntMai,
    unitValueMai,
    totalMai,
    totalAcumuladoMai,
    qntJun,
    unitValueJun,
    totalJun,
    totalAcumuladoJun,
    qntJul,
    unitValueJul,
    totalJul,
    totalAcumuladoJul,
    qntAgo,
    unitValueAgo,
    totalAgo,
    totalAcumuladoAgo,
    qntSet,
    unitValueSet,
    totalSet,
    totalAcumuladoSet,
    qntOut,
    unitValueOut,
    totalOut,
    totalAcumuladoOut,
    qntNov,
    unitValueNov,
    totalNov,
    totalAcumuladoNov,
    qntDez,
    unitValueDez,
    totalDez,
    totalAcumuladoDez,
  ]);

  return (
    <WrapperTables>
      <TableCalcStyle>
        <thead>
          <tr>
            <th>Mês</th>
            <th>Qtd</th>
            <th>R$ Unit</th>
            <th>Total</th>
            <th>Total Acumulado</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>JAN</td>
            <td>
              <input type="text" className="QntInput" onChange={(e) => setQntJan(e.target.value)} />
            </td>
            <td>
              <input
                type="text"
                className="UnitValueInput"
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace('.', '');
                  value = value.replace(',', '.');
                  setUnitValueJan(value);
                }}
              />
            </td>
            <td>
              <p>{totalJan.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalAcumuladoJan.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
          </tr>
          <tr>
            <td>FEV</td>
            <td>
              <input type="text" className="QntInput" onChange={(e) => setQntFev(e.target.value)} />
            </td>
            <td>
              <input
                type="text"
                className="UnitValueInput"
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace('.', '');
                  value = value.replace(',', '.');
                  setUnitValueFev(value);
                }}
              />
            </td>
            <td>
              <p>{totalFev.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalAcumuladoFev.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
          </tr>
          <tr>
            <td>MAR</td>
            <td>
              <input type="text" className="QntInput" onChange={(e) => setQntMar(e.target.value)} />
            </td>
            <td>
              <input
                type="text"
                className="UnitValueInput"
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace('.', '');
                  value = value.replace(',', '.');
                  setUnitValueMar(value);
                }}
              />
            </td>
            <td>
              <p>{totalMar.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalAcumuladoMar.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
          </tr>
          <tr>
            <td>ABR</td>
            <td>
              <input type="text" className="QntInput" onChange={(e) => setQntAbr(e.target.value)} />
            </td>
            <td>
              <input
                type="text"
                className="UnitValueInput"
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace('.', '');
                  value = value.replace(',', '.');
                  setUnitValueAbr(value);
                }}
              />
            </td>
            <td>
              <p>{totalAbr.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalAcumuladoAbr.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
          </tr>
          <tr>
            <td>MAI</td>
            <td>
              <input type="text" className="QntInput" onChange={(e) => setQntMai(e.target.value)} />
            </td>
            <td>
              <input
                type="text"
                className="UnitValueInput"
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace('.', '');
                  value = value.replace(',', '.');
                  setUnitValueMai(value);
                }}
              />
            </td>
            <td>
              <p>{totalMai.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalAcumuladoMai.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
          </tr>
          <tr>
            <td>JUN</td>
            <td>
              <input type="text" className="QntInput" onChange={(e) => setQntJun(e.target.value)} />
            </td>
            <td>
              <input
                type="text"
                className="UnitValueInput"
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace('.', '');
                  value = value.replace(',', '.');
                  setUnitValueJun(value);
                }}
              />
            </td>
            <td>
              <p>{totalJun.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalAcumuladoJun.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
          </tr>
        </tbody>
      </TableCalcStyle>
      <TableCalcStyle>
        <thead>
          <tr>
            <th>Mês</th>
            <th>Qtd</th>
            <th>R$ Unit</th>
            <th>Total</th>
            <th>Total Acumulado</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>JUL</td>
            <td>
              <input type="text" className="QntInput" onChange={(e) => setQntJul(e.target.value)} />
            </td>
            <td>
              <input
                type="text"
                className="UnitValueInput"
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace('.', '');
                  value = value.replace(',', '.');
                  setUnitValueJul(value);
                }}
              />
            </td>
            <td>
              <p>{totalJul.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalAcumuladoJul.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
          </tr>
          <tr>
            <td>AGO</td>
            <td>
              <input type="text" className="QntInput" onChange={(e) => setQntAgo(e.target.value)} />
            </td>
            <td>
              <input
                type="text"
                className="UnitValueInput"
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace('.', '');
                  value = value.replace(',', '.');
                  setUnitValueAgo(value);
                }}
              />
            </td>
            <td>
              <p>{totalAgo.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalAcumuladoAgo.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
          </tr>
          <tr>
            <td>SET</td>
            <td>
              <input type="text" className="QntInput" onChange={(e) => setQntSet(e.target.value)} />
            </td>
            <td>
              <input
                type="text"
                className="UnitValueInput"
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace('.', '');
                  value = value.replace(',', '.');
                  setUnitValueSet(value);
                }}
              />
            </td>
            <td>
              <p>{totalSet.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalAcumuladoSet.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
          </tr>
          <tr>
            <td>OUT</td>
            <td>
              <input type="text" className="QntInput" onChange={(e) => setQntOut(e.target.value)} />
            </td>
            <td>
              <input
                type="text"
                className="UnitValueInput"
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace('.', '');
                  value = value.replace(',', '.');
                  setUnitValueOut(value);
                }}
              />
            </td>
            <td>
              <p>{totalOut.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalAcumuladoOut.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
          </tr>
          <tr>
            <td>NOV</td>
            <td>
              <input type="text" className="QntInput" onChange={(e) => setQntNov(e.target.value)} />
            </td>
            <td>
              <input
                type="text"
                className="UnitValueInput"
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace('.', '');
                  value = value.replace(',', '.');
                  setUnitValueNov(value);
                }}
              />
            </td>
            <td>
              <p>{totalNov.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalAcumuladoNov.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
          </tr>
          <tr>
            <td>DEZ</td>
            <td>
              <input type="text" className="QntInput" onChange={(e) => setQntDez(e.target.value)} />
            </td>
            <td>
              <input
                type="text"
                className="UnitValueInput"
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace('.', '');
                  value = value.replace(',', '.');
                  setUnitValueDez(value);
                }}
              />
            </td>
            <td>
              <p>{totalDez.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
            <td>
              <p>{totalAcumuladoDez.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
            </td>
          </tr>
        </tbody>
      </TableCalcStyle>
    </WrapperTables>
  );
}
